export default function findActivePage(currentPages, currentPathname) {
  var map = {};
  var mapParent = {};
  var pathname = currentPathname.replace('/[docsTab]', '').replace('components-api', '').replace('hooks-api', '');
  var _traverse = function traverse(parent) {
    (parent.children || []).forEach(function (child) {
      var childPathname = child.pathname.replace('/[docsTab]', '').replace('components-api', '').replace('hooks-api', '');
      map[childPathname] = child;
      var isChildApiPathname = child.pathname.includes('components-api') || child.pathname.includes('hooks-api');
      if (!isChildApiPathname && mapParent[childPathname]) {
        throw new Error("Duplicated pathname ".concat(child.pathname, " in pages"));
      }
      if (!isChildApiPathname) {
        mapParent[childPathname] = parent;
      }
      _traverse(child);
    });
  };
  _traverse({
    pathname: '/',
    children: currentPages
  });
  var activePage = map[pathname] || null;
  var activePageParents = [];
  var traversePage = activePage;
  while (traversePage && traversePage.pathname !== '/') {
    var parent = mapParent[traversePage.pathname];
    activePageParents.push(parent);
    traversePage = parent;
  }
  return {
    activePage: activePage,
    activePageParents: activePageParents
  };
}